@if (show) {
  <div class="tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-full tw-flex tw-justify-center tw-items-center tw-z-[10000] tw-bg-[rgba(0,0,0,0.5)]" (click)="closePopUp()">
    <div class="popup-content tw-relative tw-overflow-y-visible tw-bg-gray-50 tw-min-w-[75vw] tw-max-w-[85vw] tw-max-h-[75vh] tw-origin-center tw-animate-anim_popup" style="width: calc(100% - 30px);" (click)="stopPropagation($event)" [style.background]="bg" [ngClass]="customClass">
      <ng-content></ng-content>
    </div>
    @if (!fullscreen) {
      <div class="tw-fixed tw-top-4 tw-right-4 tw-text-2xl tw-w-[30px] tw-h-[30px] tw-bg-gray-50 tw-rounded-full tw-flex tw-items-center tw-justify-center" style="color: var(--primary);" (click)="closePopUp()">
        <em class="cs-icon-close"></em>
      </div>
    }
  </div>
}